export const START_FETCHING_PAYMENTS = 'redux/payments/START_FETCHING_PAYMENTS';
export const SUCCESS_FETCHING_PAYMENTS = 'redux/payments/SUCCESS_FETCHING_PAYMENTS';
export const ERROR_FETCHING_PAYMENTS = 'redux/payments/ERROR_FETCHING_PAYMENTS';
export const SET_KEYWORD = 'redux/payments/SET_KEYWORD';